import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { neutral } from "app/themes/colors";
import {
  DIALER_CALL_STATE_ON_HOLD,
  DIALER_CALL_STATE_PICKED_UP,
} from "components/suno-dialer/constants";
import { DialerCallState } from "components/suno-dialer/types";

type CallItemStatusProps = {
  state?: DialerCallState;
};
export default function CallItemState({ state }: CallItemStatusProps) {
  return (
    <Box sx={{ minWidth: "60px", pl: 1 }}>
      <Typography
        sx={{
          fontSize: "13px",
          lineHeight: 1.1,
          display: "inline",
          background:
            state === DIALER_CALL_STATE_ON_HOLD
              ? neutral[800]
              : state === DIALER_CALL_STATE_PICKED_UP
              ? "rgb(57,148,108)"
              : "hsla(273, 21%, 54%, 0.8)",
          color: "white",
          borderRadius: "4px",
          p: "2px",
          px: "4px",
        }}
      >
        {state}
      </Typography>
    </Box>
  );
}
